// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/SubjectChoice/Welcome.less
// module id = 1633
// module chunks = 0